import { render } from "./TestesEquipe.vue?vue&type=template&id=637c9b91&scoped=true"
import script from "./TestesEquipe.vue?vue&type=script&lang=js"
export * from "./TestesEquipe.vue?vue&type=script&lang=js"

import "./TestesEquipe.vue?vue&type=style&index=0&id=637c9b91&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637c9b91"]])

export default __exports__